/* YourEventCard - dark pinned row/card, same on mobile (Main.dc.html) and desktop (Desktop.dc.html):
   flyer thumb, "Your events" label, title/date, entered status, CTA. */
.yourEvent {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 10px;
  border-radius: var(--r-12);
  background: var(--bg-dark);
  color: var(--text-on-dark);
}
.yourEventThumb {
  width: 48px;
  height: 64px;
  object-fit: cover;
  border-radius: 6px;
  flex-shrink: 0;
}
.yourEventLabel {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--accent-tint-text);
}
.yourEventBody {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.yourEventTitle {
  font-weight: 700;
  font-size: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-on-dark);
}
.yourEventMeta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--text-on-dark-faint);
}
.yourEventChevron {
  flex-shrink: 0;
}
.yourEventCta {
  margin-left: 12px;
  font-weight: 700;
  font-size: 15px;
  color: var(--text-on-dark);
}

@media (min-width: 1200px) {
  .yourEvent {
    padding: 12px 16px 12px 12px;
  }
  .yourEventThumb {
    width: 42px;
    height: 56px;
  }
  .yourEventLabel {
    width: 110px;
  }
  .yourEventTitle {
    white-space: normal;
  }
}

/* RaceTime / Featured promo hero - same layout shape, two color treatments (decision 8: RaceTime
   stays the dark/black sitewide-promo card; Featured is restyled to white + orange border rather
   than the artboards' black blurred-flyer hero, matching the existing event-page sidebar's own
   RaceTimeCard/FeaturedEventsCard convention). */
.promoHero {
  position: relative;
  overflow: hidden;
  border-radius: var(--r-16);
  display: flex;
  gap: 20px;
  padding: 18px;
  flex-direction: column;
}
.promoHeroDark {
  background: var(--bg-dark);
  color: var(--text-on-dark);
  box-shadow: 0 10px 32px rgba(21, 23, 26, 0.14);
}
.promoHeroLight {
  background: var(--bg-panel);
  border: 2px solid var(--accent);
}
.promoBadge {
  align-self: flex-start;
  padding: 4px 10px;
  border-radius: var(--r-pill);
  background: var(--accent);
  color: var(--text-on-dark);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
}
.promoFlyerLink {
  position: relative;
  display: block;
  width: 100%;
  height: 220px;
  flex-shrink: 0;
  border-radius: var(--r-10);
  overflow: hidden;
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.3);
}
.promoHeroDark .promoFlyerLink {
  background: var(--bg-dark-panel);
}
.promoHeroLight .promoFlyerLink {
  background: var(--border-2);
}
.promoFlyerImg {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.promoBody {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}
.promoDateLine {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: var(--accent-tint-text);
}
.promoHeroLight .promoDateLine {
  color: var(--accent-text);
}
.promoTitle {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 28px;
  line-height: 1.02;
  text-transform: uppercase;
  text-decoration: none;
}
.promoHeroDark .promoTitle {
  color: var(--text-on-dark);
}
.promoHeroLight .promoTitle {
  color: var(--text-primary);
}
.promoSubline {
  font-size: 14px;
}
.promoHeroDark .promoSubline {
  color: var(--text-on-dark-muted);
}
.promoHeroLight .promoSubline {
  color: var(--text-secondary);
}
.promoFooter {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.promoStatusRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  gap: 12px;
}
.promoProgress {
  width: 50%;
  height: 8px;
  border-radius: var(--r-pill);
  overflow: hidden;
}
.promoHeroDark .promoProgress {
  background: var(--bg-dark-panel);
}
.promoHeroLight .promoProgress {
  background: var(--border-2);
}
.promoProgressFill {
  height: 8px;
  border-radius: var(--r-pill);
  background: var(--accent);
}
.promoActionRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}
.promoMeta {
  font-size: 13px;
}
.promoHeroDark .promoMeta {
  color: var(--text-on-dark-faint);
}
.promoHeroLight .promoMeta {
  color: var(--text-muted);
}

@media (min-width: 1200px) {
  .promoHero {
    flex-direction: row;
    padding: 24px;
  }
  .promoFlyerLink {
    width: 200px;
    height: 270px;
    flex-shrink: 0;
  }
  /* Without flex-grow, a flex item with no explicit width sizes to its own content - here, the
     title's natural wrap width - instead of filling the row's remaining space next to the fixed-
     width flyer. That left every card's body (and so its progress bar, which stretches to 100%
     of it) a different width depending on how long/short the title happened to be. */
  .promoBody {
    flex: 1;
  }
}
